import { useCallback } from "react";
import { Controller } from "react-hook-form";
import { AnimatePresence } from "../../../AuthNew/shared/motionUtils";
import {
  SectionTitle,
  Input,
  InputGroup,
  InputError,
  ChipGroup,
  Chip,
} from "../../shared/onboardingStyles";
import { AuthText } from "../../../AuthNew/shared/authStyles";

const OrganizationInput = ({
  control,
  errors,
  isSubmitted,
  organizationSuggestions,
  onSuggestionClick,
  currentValue,
}) => {
  return (
    <div style={{ marginBottom: "32px" }}>
      <SectionTitle>Enter organization name</SectionTitle>
      <InputGroup>
        <Controller
          name="organizationName"
          control={control}
          render={({ field }) => (
            <Input
              {...field}
              type="text"
              placeholder="Organization name"
              hasError={!!errors.organizationName && isSubmitted}
              autoFocus
            />
          )}
        />
        <AnimatePresence>
          {errors.organizationName && isSubmitted && (
            <InputError
              initial={{ opacity: 0, y: -10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -10 }}
              transition={{ duration: 0.2 }}
            >
              {errors.organizationName.message}
            </InputError>
          )}
        </AnimatePresence>
      </InputGroup>

      {organizationSuggestions.length > 0 && (
        <ChipGroup>
          <AuthText>Try</AuthText>
          {organizationSuggestions.map((suggestion) => (
            <Chip
              key={suggestion}
              type="button"
              isSelected={currentValue === suggestion}
              onClick={() => onSuggestionClick(suggestion)}
            >
              {suggestion}
            </Chip>
          ))}
        </ChipGroup>
      )}
    </div>
  );
};

export default OrganizationInput;
